// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1503228a","312":"f43d2465","453":"2462d068","493":"58d49fe6","538":"d8798812"}[chunkId] + ".chunk.js";
};